import { render, staticRenderFns } from "./SidebarNestedItem.vue?vue&type=template&id=09986f58&scoped=true&"
import script from "./SidebarNestedItem.vue?vue&type=script&lang=js&"
export * from "./SidebarNestedItem.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNestedItem.vue?vue&type=style&index=0&id=09986f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09986f58",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListGroup,VListItem,VListItemIcon,VListItemTitle})


/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09986f58')) {
      api.createRecord('09986f58', component.options)
    } else {
      api.reload('09986f58', component.options)
    }
    module.hot.accept("./SidebarNestedItem.vue?vue&type=template&id=09986f58&scoped=true&", function () {
      api.rerender('09986f58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/SidebarNestedItem.vue"
export default component.exports